import type { FlowChildNode } from '../../../edit/flowGraph';

/**
 * The description to show on a flow node: the node's own, else its placed definition's, or null when neither has one.
 *
 * On a definition canvas the node's own is the top-level `description` (the placement's `flow_description`) and the
 * definition's is `data.description`. An instance row carries one description in both places, already resolved the same
 * way by the backend.
 */
export const shownDescription = (node: Pick<FlowChildNode, 'description' | 'data'>): string | null => node.description || node.data?.description || null;
